import React from 'react';

import { DropdownToggleInterface } from '@neptune/shared/venus-domain';

import type { Widget } from './core-widget-types';

type WidgetActionContextValue = {
  checkbox?: React.ComponentType<{ widget: Widget; onCheckedChange?: (checked: boolean) => void }>;
  exportMenu?: React.ComponentType<{
    widget: Widget;
    toggle?: React.ReactElement<DropdownToggleInterface>;
    onSelect?: () => void;
  }>;
};

export const WidgetActionContext = React.createContext<WidgetActionContextValue>({});
